import * as React from 'react'
import { alpha, styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import {
    Receipt,
    ReceiptLong,
    Settings,
    ViewModule,
    ArticleOutlined,
    PersonOutline,
    Speed,
    LocalAtm,
    RequestQuoteOutlined,
    UpdateOutlined,
    Insights,
    RemoveFromQueue,
    QueryStats,
    AccountBalance,
    ExpandLess,
    ExpandMore, Business, AutoMode, AutoAwesome, AutoAwesomeMosaicOutlined, ChromeReaderMode, ChromeReaderModeOutlined,
    Dvr, PeopleOutline, ArrowCircleDownOutlined, ArrowCircleUp, InsertPageBreak, LibraryAddCheckOutlined,
    LibraryAddCheck, LibraryBooksOutlined,
} from '@mui/icons-material'
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import StoreMallDirectoryOutlinedIcon from '@mui/icons-material/StoreMallDirectoryOutlined'
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined'

import logo from '../../assets/images/blocob3-logo-dark.png'
import logoReceita from '../../assets/images/logo-receita.png'
import CssBaseline from '@mui/material/CssBaseline'
import { useLocation } from 'react-router-dom'
import {
    Chip,
    Tooltip,
    IconButton,
    useTheme, Divider, Typography, Collapse
} from '@mui/material'
import {useContext, useEffect, useState} from "react";
import Context from "../../contexts/Context";
import {getCondoType, getRentType, hasFeature} from '../../services/Main/AuthStorage'
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const drawerWidth = 200
const financialDrawerWidth = 260 // largura maior para o modo financeiro
const railWidth = 64 // largura do mini-rail

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}))

/** ====== DENSE / COMPACT STYLES ====== */
const fontSize = 14;  // ajuste fino da fonte do menu
const denseItemButtonSx = {
    minHeight: 36,
    py: 0.3,
    borderRadius: 1,
}
const denseItemIconSx = {
    minWidth: 34,
    '& .MuiSvgIcon-root': { fontSize: 20 }
}
const denseTextProps = {
    primaryTypographyProps: {
        fontSize,
        fontWeight: 500,
        lineHeight: 1.3,
        letterSpacing: '0.2px'
    }
}
/** ==================================== */

function SubmenuItem({ text, icon, children, keyState, paths }) {
    const { dataProvider, setDataProvider } = useContext(Context)
    const location = useLocation()

    const optionSelected = () => paths?.some(path => location.pathname.includes(path));

    useEffect(() => {
        if (optionSelected()) {
            setDataProvider(prev => ({...prev, [keyState]: true}))
        }

    }, [location.pathname])

    const handleClick = () => {
        setDataProvider(prev => ({ ...prev, [keyState]: !prev?.[keyState]}))
    };

    const open = !!dataProvider?.[keyState]

    return (
        <>
            <ListItem disablePadding sx={{mt: '0.25rem'}}>
                <ListItemButton onClick={handleClick} selected={optionSelected()} sx={denseItemButtonSx}>
                    <ListItemIcon sx={denseItemIconSx}>{icon}</ListItemIcon>
                    <ListItemText {...denseTextProps} primary={text} />
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {children}
            </Collapse>
        </>
    );
}

const NewSidebar = (props) => {
    const { user, managerMode } = useContext(Context)
    const {
        perm_transfer,
        perm_dashboard,
        perm_bank,
    } = user || {}
    const theme = useTheme()
    const isFinancialMode = managerMode === 'financial'
    const currentDrawerWidth = isFinancialMode ? financialDrawerWidth : drawerWidth
    const { window } = props
    const location = useLocation()

    const container = window !== undefined ? () => window().document.body : undefined

    // Cores do modo financeiro (azul royal)
    const financialColors = {
        sidebarBg: '#0D47A1',
        accentLight: '#42A5F5',
        accentMain: '#1565C0',
    }

    const activeRootStyle = {
        fontWeight: 'bold',
        bgcolor: isFinancialMode
            ? alpha(financialColors.accentLight, theme.palette.action.selectedOpacity)
            : alpha(theme.palette.secondary.light, theme.palette.action.selectedOpacity),
        '&.Mui-selected': {
            backgroundColor: isFinancialMode
                ? alpha(financialColors.accentLight, theme.palette.action.selectedOpacity)
                : alpha(theme.palette.secondary.light, theme.palette.action.selectedOpacity)
        },
        '&.Mui-selected:hover': {
            backgroundColor: isFinancialMode
                ? alpha(financialColors.accentLight, theme.palette.action.activatedOpacity)
                : alpha(theme.palette.secondary.light, theme.palette.action.activatedOpacity)
        }
    }

    const isRoute = (p) => location.pathname.indexOf(p) > -1

    // ---------- rail / seção ativa ----------
    const [activeSection, setActiveSection] = useState('core')

    useEffect(() => {
        if (isFinancialMode) {
            setActiveSection('finance')
            return
        }
        if (isRoute('/banco')) {
            setActiveSection('bank')
        } else if (isRoute('/financeiro/') || isRoute('/relatorio-geral/')) {
            setActiveSection('finance')
        } else if (isRoute('/contatos/')) {
            setActiveSection('contact')
        } else if (isRoute('/assinatura') || isRoute('/modelo')) {
            setActiveSection('sign')
        } else {
            setActiveSection('core')
        }
    }, [location.pathname, isFinancialMode])


    const railButtonSx = (selected) => ({
        width: 44,
        height: 44,
        borderRadius: '12px',
        bgcolor: selected
            ? alpha(isFinancialMode ? financialColors.accentLight : theme.palette.primary.light, 0.28)
            : 'transparent',
        color: selected
            ? (isFinancialMode ? '#ffffff' : theme.palette.primary.contrastText)
            : 'neutral.main',
        '&:hover': {
            bgcolor: selected
                ? alpha(isFinancialMode ? financialColors.accentLight : theme.palette.primary.light, 0.36)
                : alpha(theme.palette.neutral?.main || '#fff', 0.06),
        },
        transition: 'all .15s ease',
    })

    // ---------------- menus ----------------
    const sideBarMainCore = (
        <Box sx={{ width: drawerWidth, flexShrink: 0 }}>
            <DrawerHeader>
                <Box component={'div'} sx={{ display: 'flex', alignItem: 'center', pb: 4, pt: 1 }}>
                    <Typography variant="h6" component="div" sx={{ textAlign: "center", mt: 2, fontSize: 16 }}>
                        Cobranças
                    </Typography>
                </Box>
            </DrawerHeader>

            <List dense sx={{ px: 1 }}>
                {perm_dashboard && hasFeature('dashboard') &&
                    <ListItem key={'dashboard'} disablePadding sx={{my: '0.2rem'}}>
                        <ListItemButton
                            href="/"
                            selected={location.pathname === '/'}
                            sx={{ ...(location.pathname === '/' && activeRootStyle), ...denseItemButtonSx }}>
                            <ListItemIcon sx={denseItemIconSx}><Speed sx={{ color: 'neutral.main' }}/></ListItemIcon>
                            <ListItemText {...denseTextProps} primary="Painel" />
                        </ListItemButton>
                    </ListItem>
                }

                {hasFeature('invoice') &&
                <ListItem key="invoice" disablePadding sx={{my: '0.2rem'}}>
                    <ListItemButton
                        href="/faturas"
                        selected={isRoute('/faturas')}
                        sx={{ ...(isRoute('/faturas') && activeRootStyle), ...denseItemButtonSx }}>
                        <ListItemIcon sx={denseItemIconSx}><Receipt sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText {...denseTextProps} primary="Faturas" />
                    </ListItemButton>
                </ListItem>
                }

                {perm_transfer && hasFeature('payout') &&
                    <ListItem key="repasses" disablePadding sx={{my: '0.2rem'}}>
                        <ListItemButton
                            href="/repasses"
                            selected={isRoute('/repasses')}
                            sx={{ ...(isRoute('/repasses') && activeRootStyle), ...denseItemButtonSx }}>
                            <ListItemIcon sx={denseItemIconSx}><LocalAtm sx={{ color: 'neutral.main' }}/></ListItemIcon>
                            <ListItemText {...denseTextProps} primary="Repasses" />
                        </ListItemButton>
                    </ListItem>
                }

                {(getCondoType() !== 'CONDO') &&
                    <>
                        {hasFeature('rent_contract') &&
                        <ListItem key="contratos" disablePadding sx={{my: '0.2rem'}}>
                            <ListItemButton
                                href="/contratos"
                                selected={isRoute('/contratos')}
                                sx={{ ...(isRoute('/contratos') && activeRootStyle), ...denseItemButtonSx }}>
                                <ListItemIcon sx={denseItemIconSx}><ArticleOutlined sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                <ListItemText {...denseTextProps} primary="Contratos" />
                            </ListItemButton>
                        </ListItem>
                        }

                        {hasFeature('recipient') &&
                        <ListItem key="beneficiarios" disablePadding sx={{my: '0.2rem'}}>
                            <ListItemButton
                                href="/beneficiarios"
                                selected={isRoute('/beneficiarios')}
                                sx={{ ...(isRoute('/beneficiarios') && activeRootStyle), ...denseItemButtonSx }}>
                                <ListItemIcon sx={denseItemIconSx}><PersonOutline sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                <ListItemText {...denseTextProps} primary="Beneficiários" />
                            </ListItemButton>
                        </ListItem>
                        }

                        { getCondoType() === 'RENT' && hasFeature('client') &&
                            <ListItem key="imoveis" disablePadding sx={{my: '0.2rem'}}>
                                <ListItemButton
                                    href="/alugueis/imoveis"
                                    selected={isRoute('/alugueis/imoveis')}
                                    sx={{ ...(isRoute('/alugueis/imoveis') && activeRootStyle), ...denseItemButtonSx }}>
                                    <ListItemIcon sx={denseItemIconSx}><ViewModule sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                    <ListItemText {...denseTextProps} primary="Imóveis" />
                                </ListItemButton>
                            </ListItem>
                        }

                        { getCondoType() === 'RENT' && hasFeature('inspection') &&
                            <ListItem key="vistorias" disablePadding sx={{my: '0.2rem'}}>
                                <ListItemButton
                                    href="/vistoria"
                                    selected={isRoute('/vistoria')}
                                    sx={{ ...(isRoute('/vistoria') && activeRootStyle), ...denseItemButtonSx }}>
                                    <ListItemIcon sx={denseItemIconSx}><LibraryAddCheckOutlined sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                    <ListItemText {...denseTextProps} primary="Vistorias" />
                                </ListItemButton>
                            </ListItem>
                        }

                        {/* Mantém APENAS "Clientes" no menu Cobranças (quando BUSINESS) */}
                        { getCondoType() === 'BUSINESS' && hasFeature('client') &&
                            <ListItem key="clientes" disablePadding sx={{my: '0.2rem'}}>
                                <ListItemButton
                                    href="/clientes"
                                    selected={isRoute('/clientes')}
                                    sx={{ ...(isRoute('/clientes') && activeRootStyle), ...denseItemButtonSx }}>
                                    <ListItemIcon sx={denseItemIconSx}><ViewModule sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                    <ListItemText {...denseTextProps} primary="Clientes" />
                                </ListItemButton>
                            </ListItem>
                        }

                        {(getCondoType() === 'BUSINESS' || getCondoType() === 'RENT') &&
                            <ListItem key="encargos" disablePadding sx={{my: '0.2rem'}}>
                                <ListItemButton
                                    href="/encargos-locaticios"
                                    selected={isRoute('/encargos-locaticios')}
                                    sx={{ ...(isRoute('/encargos-locaticios') && activeRootStyle), ...denseItemButtonSx }}>
                                    <ListItemIcon sx={denseItemIconSx}><RequestQuoteOutlined sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                    <ListItemText {...denseTextProps} primary="Encargos" />
                                </ListItemButton>
                            </ListItem>
                        }

                        {(getCondoType() === 'BUSINESS' || getCondoType() === 'RENT') && hasFeature('reajust') &&
                            <ListItem key="reajustes" disablePadding sx={{my: '0.2rem'}}>
                                <ListItemButton
                                    href="/reajustes"
                                    selected={isRoute('/reajustes')}
                                    sx={{ ...(isRoute('/reajustes') && activeRootStyle), ...denseItemButtonSx }}>
                                    <ListItemIcon sx={denseItemIconSx}><UpdateOutlined sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                    <ListItemText {...denseTextProps} primary="Reajustes" />
                                </ListItemButton>
                            </ListItem>
                        }

                        { perm_bank === true && hasFeature('report') &&
                            <ListItem key="relatorio-geral" disablePadding sx={{my: '0.2rem'}}>
                                <ListItemButton
                                    href="/relatorio-geral/"
                                    selected={isRoute('/relatorio-geral/')}
                                    sx={{ ...(isRoute('/relatorio-geral/') && activeRootStyle), ...denseItemButtonSx }}>
                                    <ListItemIcon sx={denseItemIconSx}><Insights sx={{ color: 'neutral.main' }}/></ListItemIcon>
                                    <ListItemText {...denseTextProps} primary="Relatório Geral" />
                                </ListItemButton>
                            </ListItem>
                        }

                        {getRentType() === 'REAL_ESTATE' && hasFeature('dimob') &&
                            <ListItem key="dimob" disablePadding sx={{my: '0.2rem'}}>
                                <ListItemButton
                                    href="/dimob"
                                    selected={isRoute('/dimob')}
                                    sx={{ ...(isRoute('/dimob') && activeRootStyle), ...denseItemButtonSx }}>
                                    <ListItemIcon sx={{ ...denseItemIconSx, minWidth: 34 }}>
                                        <img src={logoReceita} alt="Dimob" style={{width: 26}}/>
                                    </ListItemIcon>
                                    <ListItemText {...denseTextProps} sx={{ml: 0.5}} primary="Dimob" />
                                </ListItemButton>
                            </ListItem>
                        }
                    </>
                }

                { perm_bank === true && hasFeature('charge') &&
                    <ListItem key="charge" disablePadding sx={{my: '0.2rem'}}>
                        <ListItemButton
                            href="/cobranca"
                            selected={isRoute('/cobranca')}
                            sx={{ ...(isRoute('/cobranca') && activeRootStyle), ...denseItemButtonSx }}>
                            <ListItemIcon sx={denseItemIconSx}><ReceiptLong sx={{ color: 'neutral.main' }}/></ListItemIcon>
                            <ListItemText {...denseTextProps} primary="Cobranças" />
                        </ListItemButton>
                    </ListItem>
                }
            </List>
        </Box>
    )

    const sideBarMainFinance = (
        <Box sx={{ width: currentDrawerWidth, flexShrink: 0, px: isFinancialMode ? 1.5 : 0 }}>
            <DrawerHeader>
                <Box component={'div'} sx={{ display: 'flex', alignItems: 'center', pb: 5, pt: 1, gap: 1 }}>
                    {isFinancialMode &&
                        <Box
                            component="a"
                            href="/"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 50,
                                height: 50,
                                cursor: 'pointer',
                            }}
                        >
                            <img
                                src={logo}
                                alt="BlocoB3"
                                style={{ height: 50, objectFit: 'contain' }}
                            />
                        </Box>
                    }
                    <Typography variant="h6" component="div" sx={{ mt: 2, fontSize: 16 }}>
                        Gestão Financeira
                    </Typography>
                </Box>
            </DrawerHeader>

            <List>
                <ListItem key="fin-dashboard" disablePadding sx={{my: '1rem'}}>
                    <ListItemButton
                        href="/financeiro/dashboard"
                        selected={isRoute('/financeiro/dashboard')}
                        sx={{ ...(isRoute('/financeiro/dashboard') && activeRootStyle) }}
                    >
                        <ListItemIcon><QueryStats sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText primary="Dashboard" />
                    </ListItemButton>
                </ListItem>

                {perm_bank === true &&
                    <ListItem key="fin-banco" disablePadding sx={{my: '1rem'}}>
                        <ListItemButton
                            href="/banco"
                            selected={isRoute('/banco')}
                            sx={{ ...(isRoute('/banco') && activeRootStyle) }}
                        >
                            <ListItemIcon><AccountBalanceOutlinedIcon sx={{ color: 'neutral.main' }}/></ListItemIcon>
                            <ListItemText primary="Banco" />
                        </ListItemButton>
                    </ListItem>
                }

                <ListItem key="fin-pagamentos" disablePadding sx={{my: '1rem'}}>
                    <ListItemButton
                        href="/financeiro/pagamentos"
                        selected={isRoute('/financeiro/pagamentos')}
                        sx={{ ...(isRoute('/financeiro/pagamentos') && activeRootStyle) }}
                    >
                        <ListItemIcon><InsertPageBreak sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText primary="Pagamentos" />
                    </ListItemButton>
                </ListItem>

                <ListItem key="fin-recebimentos" disablePadding sx={{my: '1rem'}}>
                    <ListItemButton
                        href="/financeiro/recebimentos"
                        selected={isRoute('/financeiro/recebimentos')}
                        sx={{ ...(isRoute('/financeiro/recebimentos') && activeRootStyle) }}
                    >
                        <ListItemIcon><LibraryBooksOutlined sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText primary="Recebimentos" />
                    </ListItemButton>
                </ListItem>

                <ListItem key="fin-contatos" disablePadding sx={{my: '1rem'}}>
                    <ListItemButton
                        href="/financeiro/contatos"
                        selected={isRoute('/financeiro/contatos')}
                        sx={{ ...(isRoute('/financeiro/contatos') && activeRootStyle) }}
                    >
                        <ListItemIcon><PeopleOutline sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText primary="Contatos" />
                    </ListItemButton>
                </ListItem>

                {perm_bank === true &&
                    <ListItem key="fin-contas-bancarias" disablePadding sx={{my: '1rem'}}>
                        <ListItemButton
                            href="/financeiro/contas-bancarias"
                            selected={isRoute('/financeiro/contas-bancarias')}
                            sx={{ ...(isRoute('/financeiro/contas-bancarias') && activeRootStyle) }}
                        >
                            <ListItemIcon><AccountBalanceOutlinedIcon sx={{ color: 'neutral.main' }}/></ListItemIcon>
                            <ListItemText primary="Contas Bancárias" />
                        </ListItemButton>
                    </ListItem>
                }

                <Divider sx={{ my: 1, borderColor: alpha(theme.palette.neutral?.main || '#ffffff', 0.1) }} />

                <ListItem key="fin-configuracoes" disablePadding sx={{my: '1rem'}}>
                    <ListItemButton
                        href="/financeiro/configuracoes"
                        selected={isRoute('/financeiro/configuracoes')}
                        sx={{ ...(isRoute('/financeiro/configuracoes') && activeRootStyle) }}
                    >
                        <ListItemIcon><Settings sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText primary="Configurar" />
                    </ListItemButton>
                </ListItem>

            </List>
        </Box>
    )

    const sideBarMainSign = (
        <Box sx={{ width: drawerWidth, flexShrink: 0 }}>
            <DrawerHeader>
                <Box component={'div'} sx={{ display: 'flex', alignItem: 'center', pb: 4, pt: 1 }}>
                    <Typography variant="h6" component="div" sx={{ textAlign: "center", mt: 2, fontSize: 16 }}>
                        Assinaturas
                    </Typography>
                </Box>
            </DrawerHeader>

            <List dense sx={{ px: 1 }}>
                <ListItem disablePadding sx={{my: '0.2rem'}}>
                    <ListItemButton
                        href="/financeiro/dashboard"
                        selected={isRoute('/financeiro/dashboard')}
                        sx={{ ...(isRoute('/financeiro/dashboard') && activeRootStyle), ...denseItemButtonSx }}
                    >
                        <ListItemIcon sx={denseItemIconSx}><QueryStats sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText {...denseTextProps} primary="Painel" />
                    </ListItemButton>
                </ListItem>

                <ListItem disablePadding sx={{my: '0.2rem'}}>
                    <ListItemButton
                        href="/assinatura"
                        selected={isRoute('/assinaturas')}
                        sx={{ ...(isRoute('/assinaturas') && activeRootStyle), ...denseItemButtonSx }}
                    >
                        <ListItemIcon sx={denseItemIconSx}><AccountBalance sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText {...denseTextProps} primary="Assinaturas" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{my: '0.2rem'}}>
                    <ListItemButton
                        href="/modelo"
                        selected={isRoute('/modelo')}
                        sx={{ ...(isRoute('/modelo') && activeRootStyle), ...denseItemButtonSx }}
                    >
                        <ListItemIcon sx={denseItemIconSx}><AccountBalance sx={{ color: 'neutral.main' }}/></ListItemIcon>
                        <ListItemText {...denseTextProps} primary="Modelo" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    )

    const sideBarMainContact = (
        <Box sx={{ width: drawerWidth, flexShrink: 0 }}>
            <DrawerHeader>
                <Box component="div" sx={{ display: 'flex', alignItems: 'center', pb: 3, pt: 1 }}>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ textAlign: 'center', mt: 2, fontSize: 16 }}
                    >
                        Contatos
                    </Typography>
                </Box>
            </DrawerHeader>

            <List dense>
                {[
                    {
                        href: '/contatos/clientes',
                        icon: <Groups2OutlinedIcon sx={{ color: 'neutral.main' }} />,
                        label: 'Clientes',
                    },
                    {
                        href: '/contatos/funcionarios',
                        icon: <BadgeOutlinedIcon sx={{ color: 'neutral.main' }} />,
                        label: 'Funcionários',
                    },
                    {
                        href: '/contatos/fornecedores',
                        icon: <StoreMallDirectoryOutlinedIcon sx={{ color: 'neutral.main' }} />,
                        label: 'Fornecedores',
                    },
                    {
                        href: '/contatos/socios',
                        icon: <Diversity3OutlinedIcon sx={{ color: 'neutral.main' }} />,
                        label: 'Sócios',
                    },
                ].map(({ href, icon, label }) => (
                    <ListItem key={href} disablePadding sx={{ my: '0.2rem' }}>
                        <ListItemButton
                            href={href}
                            selected={isRoute(href)}
                            sx={{
                                ...(isRoute(href) && activeRootStyle),
                                ...denseItemButtonSx,
                                 // alinhamento idêntico ao submenu de Contatos em Financeiro
                                mx: 0.5, // leve recuo lateral como os outros menus
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    ...denseItemIconSx,
                                    minWidth: 32,
                                    color: 'neutral.main',
                                }}
                            >
                                {icon}
                            </ListItemIcon>
                            <ListItemText {...denseTextProps} primary={label} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    )

    const sideBarMainBank = (
        <Box sx={{ width: drawerWidth, flexShrink: 0 }}>
            <DrawerHeader>
                <Box component="div" sx={{ display: 'flex', alignItems: 'center', pb: 3, pt: 1 }}>
                    <Typography variant="h6" component="div" sx={{ textAlign: 'center', mt: 2, fontSize: 16 }}>
                        Banco
                    </Typography>
                </Box>
            </DrawerHeader>

            <List dense sx={{ px: 1 }}>
                {[
                    { href: '/banco', icon: <Speed sx={{ color: 'neutral.main' }} />, label: 'Visao Geral' },
                    { href: '/financeiro/extrato', icon: <AccountBalance sx={{ color: 'neutral.main' }} />, label: 'Extrato' },
                    { href: '/transferencia', icon: <SwapHorizIcon sx={{ color: 'neutral.main' }} />, label: 'Transferencias' },
                    { href: '/pagamento/list', icon: <InsertPageBreak sx={{ color: 'neutral.main' }} />, label: 'Pagamentos' },
                    { href: '/financeiro/contas-bancarias', icon: <AccountBalanceOutlinedIcon sx={{ color: 'neutral.main' }} />, label: 'Contas' },
                    { href: '/limites', icon: <MonetizationOnIcon sx={{ color: 'neutral.main' }} />, label: 'Limites' },
                ].map(({ href, icon, label }) => (
                    <ListItem key={href} disablePadding sx={{ my: '0.2rem' }}>
                        <ListItemButton
                            href={href}
                            selected={location.pathname === href || (href !== '/banco' && isRoute(href))}
                            sx={{
                                ...((location.pathname === href || (href !== '/banco' && isRoute(href))) && activeRootStyle),
                                ...denseItemButtonSx,
                                mx: 0.5,
                            }}
                        >
                            <ListItemIcon sx={{ ...denseItemIconSx, minWidth: 32, color: 'neutral.main' }}>
                                {icon}
                            </ListItemIcon>
                            <ListItemText {...denseTextProps} primary={label} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    )

    // Mini-rail (engrenagem no rodapé)
    const sideBarRail = (
        <Box
            sx={{
                width: railWidth,
                height: '100vh',
                borderRight: `1px solid ${alpha(theme.palette.neutral?.main || '#ffffff', 0.08)}`,
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                py: 2,
            }}
        >
            {/* --- Seção superior --- */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                {/* Logo */}
                <Box
                    component="a"
                    href="/"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 44,
                        height: 44,
                        borderRadius: '12px',
                        cursor: 'pointer',
                        '&:hover': {
                            bgcolor: alpha(theme.palette.neutral?.main || '#fff', 0.06),
                        },
                    }}
                >
                    <img
                        src={logo}
                        alt="BlocoB3"
                        style={{ width: 30, height: 30, objectFit: 'contain' }}
                    />
                </Box>

                <Divider
                    orientation="horizontal"
                    flexItem
                    sx={{
                        borderColor: alpha(theme.palette.neutral?.main || '#ffffff', 0.1),
                        mb: 1,
                    }}
                />

                {/* Botões principais */}
                <Tooltip title="Cobranças" placement="right">
                    <IconButton
                        onClick={() => setActiveSection('core')}
                        sx={railButtonSx(activeSection === 'core')}
                    >
                        <AutoAwesomeMosaicOutlined />
                    </IconButton>
                </Tooltip>

                {hasFeature('digital_signature') &&
                <Tooltip title="Assinatura" placement="right">
                    <IconButton
                        onClick={() => setActiveSection('sign')}
                        sx={railButtonSx(activeSection === 'sign')}
                    >
                        <Dvr />
                    </IconButton>
                </Tooltip>
                }

                <Tooltip title="Contatos" placement="right">
                    <IconButton
                        onClick={() => setActiveSection('contact')}
                        sx={railButtonSx(activeSection === 'contact')}
                    >
                        <PeopleOutline />
                    </IconButton>
                </Tooltip>

                {perm_bank === true &&
                <Tooltip title="Banco" placement="right">
                    <IconButton
                        onClick={() => setActiveSection('bank')}
                        sx={railButtonSx(activeSection === 'bank')}
                    >
                        <AccountBalanceOutlinedIcon />
                    </IconButton>
                </Tooltip>
                }

                {hasFeature('cash_flow') &&
                <Tooltip title="Gestão Financeira" placement="right">
                    <IconButton
                        onClick={() => setActiveSection('finance')}
                        sx={railButtonSx(activeSection === 'finance')}
                    >
                        <Business />
                    </IconButton>
                </Tooltip>
                }
            </Box>

            {/* --- Seção inferior --- */}
            <Box>
                <Tooltip title="Configurações" placement="right">
                    <IconButton
                        component="a"
                        href="/configuracoes/contas"
                        sx={railButtonSx(isRoute('/configuracoes/contas'))}
                    >
                        <Settings />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    )

    // Conteúdo combinado dentro do Drawer
    const sideBarContent = (
        <Box sx={{ display: 'flex', width: isFinancialMode ? currentDrawerWidth : drawerWidth + railWidth }}>
            {!isFinancialMode && sideBarRail}
            {
                isFinancialMode ? (
                    sideBarMainFinance
                ) : activeSection === 'core' ? (
                    sideBarMainCore
                ) : activeSection === 'bank' ? (
                    sideBarMainBank
                ) : activeSection === 'finance' ? (
                    sideBarMainFinance
                ) : activeSection === 'sign' ? (
                    sideBarMainSign
                ) : activeSection === 'contact' ? (
                    sideBarMainContact
                ) : null
            }

        </Box>
    )

    return (
        <>
            {user &&
                <Box sx={{ display: 'flex' }} >
                    <CssBaseline/>
                    <Box component="nav" sx={{ width: { md: isFinancialMode ? currentDrawerWidth : drawerWidth + railWidth }, flexShrink: { md: 0 }, transition: 'width 0.2s ease' }} aria-label="Bloco B3">
                        {/* Mobile */}
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={props.mobileMenu}
                            onClose={props.handleDrawerToggle}
                            ModalProps={{ keepMounted: true }}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                                '& .MuiDrawer-paper': {
                                    boxSizing: 'border-box',
                                    width: isFinancialMode ? currentDrawerWidth : drawerWidth + railWidth,
                                    transition: 'width 0.2s ease, background-color 0.3s ease',
                                },
                            }}
                            PaperProps={{
                                sx: {
                                    backgroundColor: isFinancialMode ? financialColors.sidebarBg : 'secondary.main',
                                    color: 'neutral.main',
                                }
                            }}>
                            {sideBarContent}
                        </Drawer>

                        {/* Desktop */}
                        <Drawer
                            variant="permanent"
                            open
                            sx={{
                                display: { xs: 'none', md: 'block' },
                                '& .MuiDrawer-paper': {
                                    boxSizing: 'border-box',
                                    width: isFinancialMode ? currentDrawerWidth : drawerWidth + railWidth,
                                    transition: 'width 0.2s ease, background-color 0.3s ease',
                                },
                            }}
                            PaperProps={{
                                sx: {
                                    backgroundColor: isFinancialMode ? financialColors.sidebarBg : 'secondary.main',
                                    color: 'neutral.main',
                                }
                            }}>
                            {sideBarContent}
                        </Drawer>
                    </Box>
                </Box>
            }
        </>
    )
}

export default NewSidebar
